import React from "react";
import BasicDemo from "../demo/basic.json"
import MultiBallotDemo from "../demo/multi_ballot.json"

import { ELECTION_STATUS, VOTING_ROUND_STATUS } from "../domain/election";
import { IVoter, VOTER_STATUS } from "../domain/voter";
import ChecklistOutlinedIcon from '@mui/icons-material/ChecklistOutlined';
import { Box } from "@mui/material";
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ListAltRoundedIcon from '@mui/icons-material/ListAltRounded';
import FormatListNumberedOutlinedIcon from '@mui/icons-material/FormatListNumberedOutlined';

export interface IDemo {
    label: string;
    payload: any;
    description: string;
    diagram?: React.ReactNode;
}

export const DEMOS: { [key: string]: IDemo } = {
    "basic": {
        label: "Basic",
        description: "Preference and Checklist voting types",
        payload: {
            ...BasicDemo,
            status: VOTING_ROUND_STATUS.VOTING
        },
        diagram: (
            <Box sx={{
                display: "flex",
            }}>
                <Box sx={{
                    display: "flex",
                    flexGrow: 0,
                    flexDirection: "column",
                    justifyContent: "center",
                    border: "6px solid #222",
                    borderRadius: 1,
                    padding: 0.2
                }}>
                    <ChecklistOutlinedIcon sx={{ fontSize: 42 }} />
                    <FormatListNumberedOutlinedIcon sx={{ fontSize: 45 }} />
                </Box>
            </Box>
        )
    },
    "multi_ballot": {
        label: "Multiple Ballots",
        description: "Show show multiple ballots in one election. Voters must complete and submit each ballot seperately.",
        payload: {
            ...MultiBallotDemo,
            status: VOTING_ROUND_STATUS.VOTING
        },
        diagram: (
            <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                <ListAltRoundedIcon sx={{ fontSize: 80 }} />
                <ArrowForwardRoundedIcon fontSize="large" />
                <ListAltRoundedIcon sx={{ fontSize: 80 }} />
                <ArrowForwardRoundedIcon fontSize="large" />
                <ListAltRoundedIcon sx={{ fontSize: 80 }} />
            </Box>
        )
    }
}


export const DEMO_VOTER: IVoter = {
    id: "demo_voter",
    created_at: new Date(),
    email: "voter@demo.com",
    election_id: "demo",
    first_name: "Demo",
    last_name: "Voter",
    status: VOTER_STATUS.VIEWED,
    voting_round_id: ""
}